import VOverlay from './VOverlay';
export { VOverlay };
export default VOverlay;
//# sourceMappingURL=index.js.map